export default __webpack_public_path__ + "static/media/U.3944f22c.svg";